module.exports = __webpack_public_path__ + "/build/web/images/post-convention-discount-left-1-2-mobile@2x.db996675aef4996fb3aace1e6d32357a.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/post-convention-discount-left-1-2-mobile@2x.jpg
// module id = 177
// module chunks = 13